// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { GridItemStyle } from "@insite/mobius/GridItem";
import { carouselStyles } from "@synd/Overrides/Components/ProductCompareCarousel";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, emptyValueStyles, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

carouselStyles.carouselCellGridItem = {
    width: [12, 12, 12, 10, 10],
    css: css`
        &&& {
            margin-bottom: 22px;
        }
        .swiper-slide {
            padding-right: 1px;
            > div {
                max-width: 100%;
            }
        }

        .xng-carousel-prev:not(.show-arrows-outside) {
            left: 0;
        }
        .xng-carousel-next:not(.show-arrows-outside) {
            right: 0;
        }
    `,
};

carouselStyles.attributeCellsGridItem = {
    width: 12,
    css: css``,
};

carouselStyles.attributeContainer = {
    css: css`
        display: flex;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
        &:nth-child(even) {
            background-color: ${color("common.ui2")};
        }
    `,
};

carouselStyles.attributeWrapper = {
    css: css`
        width: 100%;
    `,
};

carouselStyles.attributeValue = {
    as: "p",
    size: fontConfig.small.size,
    css: css`
        line-height: 20px;
    `,
};

carouselStyles.attributeValueText = {};

carouselStyles.mainContainer = {
    offsetCss: css`
        align-items: center;
        justify-content: center;
    `,
};

carouselStyles.emptyValueStyles = {
    ...emptyValueStyles,
};

carouselStyles.mainContainer = {
    gap: 0,
    css: css`
        margin: 0 auto;
    `,
    offsetCss: css`
        justify-content: flex-end;
    `,
};

carouselStyles.attributeLabelsCellGridItem = {
    width: [12, 12, 4, 2, 2],
    css: css`
        padding: 7px 12px;
        background-color: ${color("common.accent")};
        box-shadow: 0 -1px 0 0 inset ${color("common.ui4")};
    `,
};

carouselStyles.attributeLabel = {
    ellipsis: true,
    weight: fontConfig.weight.bold,
    size: fontConfig.smallSingleLine.size,
    lineHeight: fontConfig.smallSingleLine.lineHeight,
};

carouselStyles.attributeValuesCellGridItem = {
    width: [12, 12, 8, 10, 10],
    css: css`
        padding: 7px 12px;
        border-bottom: 1px solid transparent;
    `,
};
